import { IAiStore } from './types';

const initStore: IAiStore = {
  currentSystem: null,
  currentClinic: null,
  testAiResponse: null,
};

export default initStore;
